export const GUIA_INTERACTIVA_ENDPOINTS = {
  MI_PROGRESO: '/api/v1/guia-interactiva/mi-progreso',
  TOUR_VISTO: '/api/v1/guia-interactiva/tour-visto',
} as const;
